import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vuetify from './plugins/vuetify';
import 'document-register-element/build/document-register-element'

var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

library.add(faUserSecret)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

import vueCustomElement from 'vue-custom-element'
import PostList from './components/PostList.vue'
Vue.use(vueCustomElement)

PostList.vuetify = vuetify
Vue.customElement('gs-post-list', PostList)

